import Vue from 'vue'
import VueRouter from 'vue-router'
import { guard } from "./guards/guard";
import { afterEach } from "./afterEach";
import { RouteNamesEnum } from './RouteNamesEnum';
import { RouteConfig } from "vue-router/types/router";
import { ticketsRoutes } from "@service/router/routes/tickets-routes";
import { committeesRoutes } from "@service/router/routes/committees-routes";
import { adminRoutes } from "@service/router/routes/admin-routes";
import { expertRatingsRoutes } from "@service/router/routes/expert-ratings-routes";
import { meetingsRoutes } from "@service/router/routes/meetings-routes";
import { exampleRoutes } from './routes/example-routes';

Vue.use(VueRouter);

const isSubDomainMultitenancyType = process.env.VUE_APP_MULTITENANCY_TYPE === "Subdomain";
const startTemplateWithoutEventId = isSubDomainMultitenancyType ? '' : '/:backend';
const startTemplate = startTemplateWithoutEventId  + '/:eventId?';

//@todo think about separating all the routes to the dedicated files
const routes: RouteConfig[] = [
    {
        path: `/${isSubDomainMultitenancyType ? '' : ':backend/'}login`,
        name: RouteNamesEnum.login,
        component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: startTemplate + '/session/:id/recording',
        name: RouteNamesEnum.webConferencesRecording,
        component: () => import(/* webpackChunkName: "session" */ '../views/WebConferencesRecordingView.vue'),
        meta: {
            program: true,
            analyticName: 'webConferencesRecording'
        }
    },
    {
        path: startTemplateWithoutEventId + '/meetings/:id/public/recording',
        name: RouteNamesEnum.viewMeetingPublicRecording,
        component: () => import(/* webpackChunkName: "session" */ '../views/WebConferencesRecordingView.vue'),
        meta: {
            program: true,
            analyticName: 'Meeting recording'
        }
    },
    {
        path: startTemplate,
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/MainView.vue'),
        meta: {
            program: true,
            analyticName: 'Program'
        }
    },
    ...meetingsRoutes(startTemplateWithoutEventId, startTemplate),
    ...adminRoutes(startTemplate),
    {
        path: startTemplate + '/session/:id',
        name: RouteNamesEnum.viewSession,
        component: () => import(/* webpackChunkName: "session" */ '../views/SessionView.vue'),
        meta: {
            program: true,
            analyticName: 'Session'
        },
    },
    {
        path: startTemplate + '/invites',
        name: 'Invites',
        meta: {
            analyticName: 'Invites list'
        },
        component: () => import(/* webpackChunkName: "invites" */ '../views/Invites.vue')
    },
    {
        path: startTemplate + '/invites/:id',
        name: 'Invite',
        component: () => import(/* webpackChunkName: "invites" */ '../views/Invites.vue')
    },
    {
        path: startTemplate + '/participants',
        name: RouteNamesEnum.participants,
        component: () => import(/* webpackChunkName: "participants" */ '../views/participants/ParticipantsView.vue'),
        meta: {
            participants: true,
            analyticName: 'Participants list'
        }
    },
    {
        path: startTemplate + '/participants/:userId',
        name: 'Participant',
        component: () => import(/* webpackChunkName: "participants" */ '../views/participants/ParticipantsView.vue'),
        meta: {
            participants: true
        }
    },
    /**
     * Важно что-бы роут был объявлен выше чем роуты у которых сегмент после startTemplate динамический.
     * Если ваш роут будет находиться ниже такого роута то статичный сегмент вашего роута будет считаться динамическим сегментом другого роута
     */
    ...exampleRoutes(startTemplate),
    ...expertRatingsRoutes(startTemplate),
    ...ticketsRoutes(startTemplate),
    ...committeesRoutes(startTemplate),
    {
        path: startTemplate + '/:schemaId',
        name: 'Partners',
        component: () => import(/* webpackChunkName: "general-catalog" */ '../views/PartnerView.vue'),
        meta: {
            catalog: true,
            analyticName: 'Partners catalog'
        }
    },
    {
        path: startTemplate + '/info/:objectId',
        name: 'Info',
        component: () => import(/* webpackChunkName: "info" */ '../views/InfoView.vue')
    },
    {
        path: startTemplate + '/:schemaId/:id',
        name: 'Partner',
        component: () => import(/* webpackChunkName: "general-catalog" */ '../views/PartnerView.vue'),
        meta: {
            catalog: true,
            analyticName: 'Partner'
        }
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "home" */ '../views/errors/e404.vue')
    },
    {
        path: startTemplate + '/notfound',
        name: "404",
        component: () => import(/* webpackChunkName: "home" */ '../views/errors/e404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(guard);
router.afterEach(afterEach);

export default router
